import { render, staticRenderFns } from "./PropertyAddress.vue?vue&type=template&id=8433eee4"
import script from "./PropertyAddress.vue?vue&type=script&lang=ts"
export * from "./PropertyAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports